import { Controller } from '@hotwired/stimulus'
import LocaleDate from './shared/LocaleDate'

export default class extends Controller {
  connect () {
    this.element.innerText = LocaleDate(this.element)
  }
}
